module.exports = __webpack_public_path__ + "static/media/YF26_5.2ed74d54.jpg";